<template>
    <table class="table">
        <tr>
            <th width="200">{{ uLang('app.name') }}: </th>
            <td>{{ file.name + '.' + file.extension }}</td>
        </tr>
        <tr>
            <th>{{ uLang('app.uploaded_at') }}: </th>
            <td>{{ file.updated_at | dateForHumans }}</td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: 'BasicInfoTable',

        props: {
            file: {
                type: Object,
                required: true,
                default: () => {}
            },
        },
    }
</script>

<style scoped lang="scss">
.table {
    tr:first-child {
        td, th {
            border-top: none;
        }
    }
    td {
        padding-left: 0px !important;
    }
}
</style>
